import { createClient } from "@supabase/supabase-js";
import { SUPABASE_CLIENT_KEY, SUPABASE_URL } from "../keys";

export const SHARED_SUPABASE_CLIENT = createClient(
    SUPABASE_URL,
    SUPABASE_CLIENT_KEY
);
